import { LoginFlow, SetLoginFlow } from './LoginScreen.types';
export const getIsSimplifiedLogin = (param)=>{
    let { setLoginFlow, locationSearch, hasVendorAccount } = param;
    const clientView = new URLSearchParams(locationSearch).get('view') === 'client';
    if (setLoginFlow != null) return setLoginFlow === SetLoginFlow.OtpLogin;
    // in case we didnt come from notification or no-access page and we have a cookie
    if (hasVendorAccount != null) return !hasVendorAccount;
    return clientView;
};
export const getLoginScreenTexts = (param)=>{
    let { isSimplifiedLogin, isAccessProposalLogin, accessProposalTitle, accessProposalEmailPrompt, welcomeToAnchor, enterEmailToAccessAccount } = param;
    return {
        welcomeText: isAccessProposalLogin ? accessProposalTitle : welcomeToAnchor,
        emailPromptText: isAccessProposalLogin ? accessProposalEmailPrompt : enterEmailToAccessAccount,
        isAccessProposalTitle: isAccessProposalLogin,
        welcomePlacement: isSimplifiedLogin ? 'emailSubtitle' : 'title'
    };
};
export function getTheNextStep(param) {
    let { flow, isSimplifiedLogin } = param;
    if (isSimplifiedLogin) {
        return LoginFlow.OTP;
    }
    if (flow === LoginFlow.EmailVerification) {
        return LoginFlow.EmailVerification;
    }
    return flow;
}
